import * as React from 'react'
import VehicleActivityBarWithDate from './VehicleActivityBarWithDate'

const VehicleActivityBarWithDateWrapper: React.FC = () => {
  return <VehicleActivityBarWithDate />
}

export default VehicleActivityBarWithDateWrapper
